export const LOCAL_BASE_URL = 'http://127.0.0.1:8000';
export const SERVER_BASE_URL = 'https://ay64ksey5e.execute-api.ap-northeast-2.amazonaws.com/taki-chalice-web-api'
